<template>
  <div class="text-input" :class="getValidationClasses()">
    <div class="text-input__label" v-html="label" />
    <div class="text-input__value">
      <input type="text"
        @input="input"
        @focus="focus"
        @blur="blur"
        @change="$emit('change', $event)"
        @click="$emit('click')"
        :value="value"
        :placeholder="placeholder"
        :readonly="readonly">
    </div>
    
    <div v-if="errors.has(validationField(validateAs))" class="v-field-error">{{ errors.first(validationField(validateAs)) }}</div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import CustomControlValidationMixin from '@/components/CustomControlValidationMixin'

@Component({
  mixins: [
    CustomControlValidationMixin,
  ],
  props: {
    value: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: () => '&nbsp;',
    },
    placeholder: {
      type: String,
      required: false,
    },
    firstLetterUppercase: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    validateAs: {
      type: String,
      required: false,
    },
  },
})
export default class TextInput extends Vue {  
  upperCaseFirstLetter (e) {
    if (e.target.value) {
      this.$emit('input', e.target.value[0].toUpperCase() + e.target.value.substr(1))
    }
  }

  input (e) {
    if (this.firstLetterUppercase) this.upperCaseFirstLetter(e)
    else this.$emit('input', e.target.value)
  }

  focus (e) {
    this.$emit('focus', e)
  }

  blur (e) {
    this.$emit('blur', e)
  }
}
</script>

<style lang="scss">
@import '../FormValidationIndicator.scss';

.text-input {
  @include form-validation-indicator(21px, 5px);

  display: flex;
  flex-direction: column;
  font-weight: lighter;
  
  &__label {
    font-size: 12px;
  }
  
  &__value {
    font-size: 13px;
    position: relative;

    input {
      background-color: transparent;
      border: none;
      border-bottom: 1px solid #0057A8;
      border-radius: 0;
      padding: 5px 0 7px;
      width: 100%;
      outline: none;

      &::placeholder {
        color: inherit;
        opacity: .5;
      }
    }
  }

  &--focus:not(.field-invalid) .text-input__value {
    color: #009FEA;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/fields/TextInput.vue